export default class RemoveFollower {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  /**
   * Retirer un abonné
   * @param {string} currentUserId - ID de l'utilisateur courant
   * @param {string} followerId - ID de l'abonné à retirer
   * @returns {Promise<boolean>} - Résultat de l'opération
   */
  async execute(currentUserId, followerId) {
    if (!currentUserId || !followerId) {
      throw new Error('Les identifiants d\'utilisateur sont requis');
    }

    try {
      console.log(`RemoveFollower - Suppression de l'abonné: ${followerId} de ${currentUserId}`);
      return await this.userRepository.removeFollower(currentUserId, followerId);
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'abonné:', error);
      throw error;
    }
  }
} 